module.exports = __webpack_public_path__ + "img/pic1.a716bfe5.png";